import { render } from "./CompletePartnerClient.vue?vue&type=template&id=541e6182&scoped=true"
import script from "./CompletePartnerClient.vue?vue&type=script&lang=js"
export * from "./CompletePartnerClient.vue?vue&type=script&lang=js"

import "./CompletePartnerClient.vue?vue&type=style&index=0&id=541e6182&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541e6182"]])

export default __exports__